import { styled } from '@mui/material/styles';
import { Datagrid, DateField, FunctionField, ReferenceField, TextField, useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import NotificationBox from '@/components/global/fields/NotificationBox.jsx';
import SimpleList from '@/components/global/list/SimpleList.jsx';

const StyledHistory = styled('div')(() => ({}));

const ChangesField = ({ record, translate }) => {
    if (!record.changes || record.changes.length === 0) {
        return <span>—</span>;
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {record.changes.map((changeObj, idx) => {
                const entries = Object.entries(changeObj);
                return entries.map(([field, diff]) => {
                    const label = translate(`resources.product.fields.${field}`, { _: field });
                    return (
                        <Typography key={`${idx}-${field}`} variant='body2' sx={{ whiteSpace: 'nowrap' }}>
                            <strong>{label}:</strong> {String(diff.old ?? '—')} → {String(diff.new ?? '—')}
                        </Typography>
                    );
                });
            })}
        </Box>
    );
};

export const ProductHistory = ({ productId }) => {
    const translate = useTranslate();

    return (
        <StyledHistory>
            <SimpleList
                resource={`product/${productId}/history`}
                sort={{ field: 'createdAt', order: 'DESC' }}
                storeKey={`product-history-${productId}`}
                perPage={50}
                disablePagination
                empty={
                    <NotificationBox variant='info' className='large'>
                        {translate('resources.product.labels.noHistory')}
                    </NotificationBox>
                }
            >
                <Datagrid bulkActionButtons={false} sort={false}>
                    <FunctionField
                        label={translate('resources.product.history.action')}
                        render={record => translate(`resources.product.history.actions.${record.action}`, { _: record.action })}
                    />
                    <TextField source='source' label={translate('resources.product.history.source')} sortable={false} />
                    <FunctionField
                        label={translate('resources.product.history.changes')}
                        render={record => <ChangesField record={record} translate={translate} />}
                    />
                    <DateField source='createdAt' label={translate('resources.product.history.createdAt')} showTime sortable={false} />
                    <ReferenceField
                        source='createdBy'
                        reference='user'
                        label={translate('resources.product.history.createdBy')}
                        sortable={false}
                        link={false}
                        emptyText={translate('resources.product.history.createdByDefault')}
                    >
                        <FunctionField render={record => `${record.firstName} ${record.lastName} (${record.email})`} />
                    </ReferenceField>
                </Datagrid>
            </SimpleList>
        </StyledHistory>
    );
};
